export const API_URL = process.env.REACT_APP_API_URL;

export function getPresaleUrl(id) {
  return API_URL + "/presale/restart/" + id;
}
